"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: crypto/enrollment.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcrypto%2Fenrollment.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrollmentStatusToJSON = exports.enrollmentStatusFromJSON = exports.Enrollment = exports.EnrollmentStatus = void 0;
const protobufPackage = 'com.step.crypto.proto';
/**
 * Crypto enrollment status.
 */
var EnrollmentStatus;
(function (EnrollmentStatus) {
    EnrollmentStatus["INVALID_ENROLLMENT_STATUS"] = "INVALID_ENROLLMENT_STATUS";
    EnrollmentStatus["ACTIVE"] = "ACTIVE";
    EnrollmentStatus["INACTIVE"] = "INACTIVE";
    EnrollmentStatus["SUSPENDED"] = "SUSPENDED";
    EnrollmentStatus["CLOSED"] = "CLOSED";
    EnrollmentStatus["SELL_ONLY"] = "SELL_ONLY";
    EnrollmentStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(EnrollmentStatus || (exports.EnrollmentStatus = EnrollmentStatus = {}));
function createBaseEnrollment() {
    return { createdAtMs: '0', status: EnrollmentStatus.INVALID_ENROLLMENT_STATUS };
}
exports.Enrollment = {
    fromJSON(object) {
        const message = {
            createdAtMs: isSet(object.createdAtMs) ? globalThis.String(object.createdAtMs) : '0',
            status: isSet(object.status)
                ? enrollmentStatusFromJSON(object.status)
                : EnrollmentStatus.INVALID_ENROLLMENT_STATUS,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.status !== EnrollmentStatus.INVALID_ENROLLMENT_STATUS) {
            obj.status = enrollmentStatusToJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.Enrollment.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnrollment();
        message.createdAtMs = object.createdAtMs ?? '0';
        message.status = object.status ?? EnrollmentStatus.INVALID_ENROLLMENT_STATUS;
        return message;
    },
};
function enrollmentStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_ENROLLMENT_STATUS':
            return EnrollmentStatus.INVALID_ENROLLMENT_STATUS;
        case 1:
        case 'ACTIVE':
            return EnrollmentStatus.ACTIVE;
        case 2:
        case 'INACTIVE':
            return EnrollmentStatus.INACTIVE;
        case 3:
        case 'SUSPENDED':
            return EnrollmentStatus.SUSPENDED;
        case 4:
        case 'CLOSED':
            return EnrollmentStatus.CLOSED;
        case 5:
        case 'SELL_ONLY':
            return EnrollmentStatus.SELL_ONLY;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return EnrollmentStatus.UNRECOGNIZED;
    }
}
exports.enrollmentStatusFromJSON = enrollmentStatusFromJSON;
function enrollmentStatusToJSON(object) {
    switch (object) {
        case EnrollmentStatus.INVALID_ENROLLMENT_STATUS:
            return 'INVALID_ENROLLMENT_STATUS';
        case EnrollmentStatus.ACTIVE:
            return 'ACTIVE';
        case EnrollmentStatus.INACTIVE:
            return 'INACTIVE';
        case EnrollmentStatus.SUSPENDED:
            return 'SUSPENDED';
        case EnrollmentStatus.CLOSED:
            return 'CLOSED';
        case EnrollmentStatus.SELL_ONLY:
            return 'SELL_ONLY';
        case EnrollmentStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.enrollmentStatusToJSON = enrollmentStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=enrollment.js.map